import { Link } from '@tanstack/react-router';
import type { JSX } from 'react';

import { AREE } from './data/aree.ts';
import { GRUPPI_NAV, ESTERNE } from './data/navigazione.ts';
import { INCIDENTI } from './data/incidenti.ts';

const PROPRIE: Record<string, string> = {
  stato: 'Stato della piattaforma',
  grafo: 'Corpora e snapshot',
  aiuto: 'Risoluzione assistita',
};
const IA = ['grafo', 'aiuto'];

/**
 * Navigazione del cruscotto: 17 voci in 6 gruppi.
 *
 * DUE REGOLE CHE NON VANNO PERSE:
 *
 * 1. Lo stato attivo si esprime con `aria-current="page"` derivato da
 *    `vista === id`, MAI dal booleano di un'altra voce. Nel prototipo la
 *    condizione "voce inattiva" era scritta come "l'altra vista è attiva":
 *    aggiungendo la terza vista entrambe le voci sono scomparse e il cruscotto
 *    è diventato un vicolo cieco.
 *
 * 2. Le voci esterne (`ESTERNE`) sono <Link>, non cambi di vista. Nel mockup
 *    erano `window.location.href` e portavano fuori senza ritorno.
 */
export function ConsoleNav({ vista, onVista }: { readonly vista: string; readonly onVista: (v: string) => void }): JSX.Element {
  return (
    <nav className="uc-nav" aria-label="Aree della piattaforma">
      {[['CRUSCOTTO', ['stato', 'aiuto']] as [string, string[]], ...GRUPPI_NAV].map(([titolo, ids]) => (
        <div key={titolo}>
          <div className="uc-nav-gruppo">{titolo}</div>
          {ids.map((id) => {
            const esterna = ESTERNE[id];
            const nome = esterna?.nome ?? PROPRIE[id] ?? AREE[id]?.nome ?? id;
            const cls = IA.includes(id) ? 'ia tondo' : undefined;

            if (esterna) {
              return (
                <Link key={id} to={esterna.href} className={'uc-nav-voce ' + (cls ?? '')}>
                  <span className="pallino" aria-hidden="true" />{nome}
                </Link>
              );
            }
            return (
              <button
                key={titolo + id}
                type="button"
                className={cls}
                aria-current={vista === id ? 'page' : undefined}
                onClick={() => { onVista(id); }}
              >
                <span className="pallino" aria-hidden="true" />{nome}
              </button>
            );
          })}
        </div>
      ))}
      <div className="uc-nav-meta">
        <div>build 2.4.0-rc3</div>
        <div>realm urania-test</div>
        <div>{INCIDENTI.length} problemi aperti</div>
      </div>
    </nav>
  );
}
